import { render, staticRenderFns } from "./quotes.vue?vue&type=template&id=11aad16c&"
import script from "./quotes.vue?vue&type=script&lang=ts&"
export * from "./quotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports